import React, { FC, ReactNode } from "react";

import { BaseComponentProps } from "@keepeek/refront-components";
import { Box, Grid } from "@mui/material";
import clsx from "clsx";

export type MediaDetailScrollLayoutProps = {
  viewer: ReactNode;
  navigation: ReactNode;
  actions: ReactNode;
  title: ReactNode;
  kTemplates: ReactNode;
} & BaseComponentProps;

const MediaDetailScrollLayout: FC<React.PropsWithChildren<MediaDetailScrollLayoutProps>> =
  function MediaDetailScrollLayout({ viewer, kTemplates, navigation, actions, title, className }) {
    return (
      <Grid className={clsx("MediaDetailScrollLayout", className)} container>
        <Grid item xs={12} md={12}>
          {navigation}
        </Grid>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              backgroundColor: "secondary.dark",
              "& .KViewer": {
                "& .PictureViewer, & .rmmViewerContainer, & .audioViewerContainer, & .PlayerViewer":
                  {
                    height: "70vh",
                  },
              },
            }}
          >
            {viewer}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          {actions}
        </Grid>
        <Grid item xs={12} md={12}>
          {title}
        </Grid>
        <Grid item xs={12} md={12}>
          {kTemplates}
        </Grid>
      </Grid>
    );
  };

export default MediaDetailScrollLayout;
